import React, { memo, useCallback, useEffect, useState } from 'react';
import { AiFillDislike, AiFillLike } from 'react-icons/all';
import useAuth from 'src/hooks/useAuth';
import enRoles from 'src/models/enums/enRoles';

import { enStatus, enStatusCode, enStatusColor } from 'src/models/interfaces/reservation';
import { Dot, TRBody } from './styles';

const dateFormat = { year: 'numeric', month: 'numeric', day: 'numeric' };

interface IProps {
  checkbox: boolean;
  item: any,
  isChecked: (id: number) => boolean;
  onClick?: (checked: boolean, item: any) => void;
  colsPref: string[];
}

const GridItem = ({
  checkbox,
  item,
  onClick,
  isChecked,
  colsPref
}: IProps) => {
  const [checked, setChecked] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    setChecked(isChecked(item.id));
  }, [isChecked, item.id]);

  const handleCheck = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(e.currentTarget.checked);
    if (onClick) onClick(e.currentTarget.checked, item);
  }, [item, onClick]);

  const CheckBox = memo(() => {
    return (<>{checkbox ? (
      <td className="check" >
        <input type="checkbox" checked={checked} onChange={handleCheck} disabled={item.statusCode === enStatusCode.canceled} />
      </td>) :
      ''
    }</>);
  });

  return (
    <TRBody>
      <CheckBox />
      {colsPref.length > 0 &&
        <>
          {colsPref.includes('country') && <td className="nowrap">{item.country}</td>}
          {colsPref.includes('state') && <td className="nowrap">{item.state}</td>}
          {colsPref.includes('city') && <td className="nowrap">{item.city}</td>}
        </>
      }
      <td className="nowrap">{item.fullName}</td>
      <td className="nowrap">{item.buildingTitle}</td>
      <td>{item.floor?.toString() && `${item.floor}º`}</td>
      <td>{item.section}</td>
      <td>{item.desk}</td>
      <td>{new Date(item.date).toLocaleDateString('pt-BR', dateFormat)}</td>
      <td className="nowrap">{item.statusCode && <>
        <Dot color={enStatusColor[item.statusCode]} />{enStatus[item.statusCode]}
      </>}</td>
      {user && [enRoles.sysAdmin, enRoles.doctor].includes(user.roles) &&
        <td className="nowrap">{item.pem ? <><AiFillLike className="like" /> Sim</> : <><AiFillDislike className="dislike" /> Não</>}</td>}
    </TRBody>
  );
}

export default GridItem;